import ContainerValidation from "./Components/ContainerValidation";
import HeaderValidation from "./Components/HeaderValidation";
import BodyValidation from "./Components/BodyValidation";
import {IconAccountBlocked} from "../../../../components/buttons/IconButtons";
import React from "react";
import {useTranslation} from "react-i18next";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 13 de 01 de 2026
 */

const AccountBlocked = () => {
    const { t } = useTranslation();

    return (
        <ContainerValidation>
            <HeaderValidation showBtnBack={false}/>

            <BodyValidation
                showBtnNext={false}
                showBtnPrev={false}
            >
                <>
                    <div className="row">
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center gap-3">
                            <h1 className={"ibl-font-w-600 fs-24-to-18 font-color-shades-950"}>{t("account_blocked")}</h1>
                            <p className="fs-20-to-14 ibl-font-w-400 font-color-primary-950 text-center">{t("account_blocked_msg")}</p>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center">
                        <IconAccountBlocked className="w-100 h-100" />
                    </div>
                </>
            </BodyValidation>
        </ContainerValidation>
    )
}

export default AccountBlocked
